import {
  WistiaPlayer,
  WistiaPreloader,
  WistiaTests,
  SpeedControlButton,
} from './components';
import video from './reducer';

export {
  WistiaPlayer,
  WistiaPreloader,
  WistiaTests,
  SpeedControlButton,
  video,
};

export {
  setPlaybackRate,
  setPlaybackVolume,
  setCaptionsVisible,
  addVideoElement,
} from './reducer';
